/** Formats a number as Brazilian currency, e.g. 35 → "R$ 35,00". */
export function formatBRL(value: number): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}
